import { render, staticRenderFns } from "./RoomExtTrPopup.vue?vue&type=template&id=b562f072&scoped=true&"
import script from "./RoomExtTrPopup.vue?vue&type=script&lang=js&"
export * from "./RoomExtTrPopup.vue?vue&type=script&lang=js&"
import style0 from "./RoomExtTrPopup.vue?vue&type=style&index=0&id=b562f072&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b562f072",
  null
  
)

export default component.exports